<div class="panel-header">
  @if (nested) {
    <button
      mat-icon-button
      type="button"
      [attr.aria-label]="backAriaLabel"
      (click)="closed.emit()"
    >
      <mat-icon>arrow_back</mat-icon>
    </button>
  }
  <span class="mat-subtitle-2 panel-title">{{ title }}</span>
  <div class="panel-header-actions">
    <ng-content select="[panel-actions]"></ng-content>
    @if (!nested) {
      <button
        mat-icon-button
        type="button"
        [attr.aria-label]="closeAriaLabel"
        (click)="closed.emit()"
      >
        <mat-icon>close</mat-icon>
      </button>
    }
  </div>
</div>
<div class="panel-body">
  <ng-content></ng-content>
</div>
<div class="panel-footer">
  <ng-content select="[panel-footer]"></ng-content>
</div>
